module.exports = __webpack_public_path__ + "img/sao-paulo.5a3784df.jpg";